import { render, staticRenderFns } from "./PersonalTraining.vue?vue&type=template&id=1033ad5d&scoped=true"
import script from "./PersonalTraining.vue?vue&type=script&lang=js"
export * from "./PersonalTraining.vue?vue&type=script&lang=js"
import style0 from "./PersonalTraining.vue?vue&type=style&index=0&id=1033ad5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1033ad5d",
  null
  
)

export default component.exports